import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { validateEditPatch } from 'logic/bookingForm';
import moment from 'logic/moment';
import { DatePicker } from 'components/FormInputs';
import { useFormik } from 'components/shared/Formik';

const EditForm = ({ onSubmit, booking }) => {
  const intl = useIntl();
  const formik = useFormik({
    onSubmit: async (values) => {
      return onSubmit(values);
    },
    validateOnChange: false,
    validateOnBlur: true,
    validate: validateEditPatch({ intl }),
    initialValues: {
      booking_expiration_date: booking.booking_expiration_date,
    },
  });

  const {
    values,
    errors,
    handleSubmit,
    setFieldValue,
    isSubmitting,
    isValid,
    pristine,
    handleBlur,
  } = formik;

  return (
    <Box m={2}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <form onSubmit={handleSubmit} noValidate>
            <DatePicker
              name="booking_expiration_date"
              value={values.booking_expiration_date || null}
              onBlur={handleBlur}
              onChange={(date) => {
                if (date) {
                  setFieldValue('booking_expiration_date', date);
                }

                if (date === null) {
                  setFieldValue('booking_expiration_date', null);
                }
              }}
              label={
                <FormattedMessage
                  id="bookingForm.offerValidTill"
                  defaultMessage="Time limit for guest to accept?"
                />
              }
              cancelLabel={<FormattedMessage id="Cancel" defaultMessage="Cancel" />}
              clearLabel={<FormattedMessage id="Clear" defaultMessage="Clear" />}
              errors={errors}
              minDate={moment().format()}
              maxDate={moment(booking.check_in).format()}
              required
              disabled={!booking.check_in}
            />
            <Typography variant="body2">
              <FormattedMessage
                id="bookingForm.expirationRecommendation"
                defaultMessage="Guest accepts booking offer by paying the full rent"
              />
            </Typography>
            <Box mt={2}>
              <Button
                variant="contained"
                color="primary"
                disabled={pristine || isSubmitting || !isValid}
                type="submit"
              >
                <FormattedMessage id="Save" defaultMessage="Save" />
              </Button>
            </Box>
          </form>
        </Grid>
      </Grid>
    </Box>
  );
};

EditForm.propTypes = {
  booking: PropTypes.shape({
    check_in: PropTypes.string.isRequired,
    booking_expiration_date: PropTypes.string.isRequired,
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default EditForm;
